import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'does_the_fac_prov_inkind_benefits_in_line_w_legal_reqs'

export const dataPointDefinition = {
  retracedId: 'does_the_fac_prov_inkind_benefits_in_line_w_legal_reqs',
  name: 'Does the facility provide in-kind benefits in line with legal requirements?',
  description:
    "In-kind benefits could include, e.g., transportation, meals, housing, or child care for which the cost is deducted directly from workers' wages. Payments in the form of drugs or liquor are prohibited. Wages may be paid only partly in kind since workers must have enough cash to meet their subsistence needs and those of their family.\r\r\n\r\r\nConsult applicable legal requirements before answering this question.\r\r\n\r\r\nLegal requirements might stipulate that only certain types or amounts of in-kind benefits are allowed or that certain types of in-kind benefits must be provided (e.g. housing in some countries for foreign workers) \r\r\n\r\r\nIf there are no applicable legal requirements, answer No applicable legal requirements.",
  meta: {},
  fieldTypeId: 'SELECT',
  type: 'RELATIONAL',
  options: [
    {
      name: 'Yes',
      key: 'YES',
      slcpIndex: 1,
      slcpOptionName: 'yes-no-nalr',
    },
    {
      name: 'No',
      key: 'NO',
      slcpIndex: 2,
    },
    {
      name: 'No applicable legal requirements',
      key: 'NO_APPLICABLE_LEGAL_REQS',
      slcpIndex: 3,
      slcpOptionName: 'yes-no-nalr',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
        enum: ['YES', 'NO', 'NO_APPLICABLE_LEGAL_REQS'],
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'wb-22--1',
      version: '1.6.0',
      provider: 'slcp',
    },
  ],
  sortingId: 9400,
  sectionId: '2.2.3',
  impactArea: 'Compensation',
  impactAreaId: 'WAGES_AND_BENEFITS',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
